import axios from "axios";

const baseUrl = process.env.REACT_APP_BASE_URL;

const createHeaders = (token) => {
  const headers = {
    "Content-Type": "application/json", // Adjust content type as needed
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
};

const get = async (url, token) => {
  try {
    const response = await axios.get(baseUrl + url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error; // Re-throw for handling in the calling component
  }
};

const post = async (url, data, token) => {
  try {
    console.log("POST", baseUrl + url);
    const response = await axios.post(baseUrl + url, data, {
      headers: createHeaders(token),
    });
    return response.data;
  } catch (error) {
    throw error; // Re-throw for handling in the calling component
  }
};

const api = {
  get,
  post,
};

export default api;

